var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignTx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    viewBox: "0 0 400 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.924 82.4475C189.504 69.84 183.901 60.1609 172.829 54.2167C148.527 41.1674 119.928 42.6727 93.5619 47.4609C73.9854 51.016 49.5403 58.1624 39.2436 76.9452C36.5783 81.8053 35.1763 87.2357 35.0119 92.7688C34.4521 111.922 53.7206 120.419 69.6099 123.943C93.6287 129.276 118.382 124.858 142.555 130.155C154.803 132.842 165.855 139.217 163.143 153.628C159.815 171.317 141.261 177.733 125.525 179.583C104.362 182.069 79.1209 182.676 61.0849 169.416",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: 471
  }, /*#__PURE__*/React.createElement("animate", {
    id: "glitterSignAnimation",
    attributeName: "stroke-dashoffset",
    from: 471,
    to: 0,
    dur: "1s",
    begin: "0s;glitterSignAnimation.end+500ms"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.759 103.014C181.268 102.729 177.608 106.836 179.518 110.805C181.413 114.731 187.156 115.031 189.971 111.75C192.438 108.877 190.249 103.299 185.759 103.014Z",
    stroke: "white",
    strokeWidth: 5,
    strokeDasharray: 36
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 36,
    to: 0,
    dur: "1s",
    begin: "0s;glitterSignAnimation.end+500ms"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.941 133L182.525 149.112C182.326 156.858 179.838 172.717 187.756 177.833C189.574 179.009 191.874 179.18 194.007 178.855C207.42 176.792 214.525 164.249 220 152.949",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: 92
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 92,
    to: 0,
    dur: "1s",
    begin: "0s;glitterSignAnimation.end+500ms"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M253.513 142.072C253.513 142.072 246.467 134.951 237.803 137.584C229.14 140.217 214.555 151.36 220.307 169.302C226.059 187.244 247.823 171.654 248.239 157.98L248.069 175.038L247.735 208.627C247.638 218.339 247.771 228.097 247.407 237.805C247.099 246.05 246.313 254.494 243.992 262.448C242.502 267.545 239.791 274.931 233.695 275.902C233.228 275.979 232.755 276.004 232.283 275.999C216.81 275.688 216.43 258.512 226.891 232.596C237.351 206.679 248.259 197.56 253.847 190.618C259.434 183.676 278.024 156.651 279 151.503",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: 373
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 373,
    to: 0,
    dur: "1s",
    begin: "0s;glitterSignAnimation.end+500ms"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278 154.736C279.281 151.548 280.695 148.4 282.231 145.317C283.404 142.956 287.513 133.192 291.196 134.054C293.051 134.485 295.12 136.6 295.689 138.324C296.093 139.553 296.129 140.866 296.129 142.154C296.129 152.886 293.886 163.553 294.193 174.28C294.218 175.222 294.331 177.287 295.832 176.966C296.416 176.841 296.862 176.385 297.22 175.914C298.803 173.859 300.181 171.738 301.59 169.558C304.94 164.375 307.773 158.881 310.959 153.603C313.726 149.021 316.769 143.332 321.328 140.189C322.952 139.071 324.632 138.735 326.486 139.648C329.534 141.152 330.83 144.791 330.989 148.129C331.169 151.919 330.871 155.803 330.866 159.598C330.856 165.172 329.022 172.987 335.692 175.543C342.034 177.974 347.894 175.493 351.869 170.465C356.403 164.736 360.358 158.27 364 151.964",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: 202
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 202,
    to: 0,
    dur: "1s",
    begin: "0s;glitterSignAnimation.end+500ms"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignTx);
export default __webpack_public_path__ + "static/media/signTx.88f15144.svg";
export { ForwardRef as ReactComponent };